/** Mesmo e-mail validado no backend (InternalAdminGate). */
export const ALLOWED_INTERNAL_ADMIN_EMAIL = 'daniel.silvalima89@gmail.com';
